import clsx from 'clsx';
import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.822 32.822A25 25 0 0 1 37.5 25.5h125a25.003 25.003 0 0 1 25 25v100c0 6.63-2.634 12.989-7.322 17.678A25.004 25.004 0 0 1 162.5 175.5h-125a25.001 25.001 0 0 1-25-25v-100a25 25 0 0 1 7.322-17.678ZM37.5 38A12.5 12.5 0 0 0 25 50.5v100A12.5 12.5 0 0 0 37.5 163h125a12.501 12.501 0 0 0 12.5-12.5v-100A12.5 12.5 0 0 0 162.5 38h-125Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M117.992 55.992A18.749 18.749 0 0 1 150 69.25 18.747 18.747 0 0 1 131.25 88a18.749 18.749 0 0 1-13.258-32.008ZM131.25 63a6.248 6.248 0 0 0-6.25 6.25 6.247 6.247 0 0 0 6.25 6.25 6.248 6.248 0 0 0 6.25-6.25 6.247 6.247 0 0 0-6.25-6.25ZM62.052 91.167a18.75 18.75 0 0 1 25.696.759l35.417 35.341a6.25 6.25 0 0 1-8.83 8.849l-35.416-35.342a6.252 6.252 0 0 0-8.568-.26c-.001.001 0 0 0 0l-47.448 42.182a6.25 6.25 0 0 1-8.305-9.342l47.454-42.187Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M148.519 125.121a6.251 6.251 0 0 0-8.413.395l-48.187 48.179a6.25 6.25 0 0 1-8.838-8.84l48.179-48.171a18.752 18.752 0 0 1 25.25-1.175l.009.007 28.734 23.959a6.249 6.249 0 0 1 .797 8.802 6.25 6.25 0 0 1-8.803.798l-28.728-23.954c-.001-.001.001.001 0 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export type ImageMissingProps = {
  size: 'sm' | 'md' | 'lg';
  title?: string;
};

export const ImageMissing = ({
  size,
  title = 'Bilde mangler',
}: ImageMissingProps) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-center w-full h-full text-center text-neutral-60 p-1',
        { 'p-5': size === 'md' || size === 'lg' }
      )}
      title={title}
    >
      <div>
        <SvgComponent
          className={clsx({
            'w-6 h-6': size === 'sm',
          })}
        />
        <span
          className={clsx({
            hidden: size === 'sm',
          })}
        >
          {title}
        </span>
      </div>
    </div>
  );
};
